<template>
  <div class="filters-main">
    <div class="filters">
      <div class="filter-items">
        <div class="filter-title">
          <div>
            <span v-if="isRequired" class="required-asterisks">**</span>
            <span>{{ title }}</span>
          </div>
          <button v-if="!isDisabled" @click="showTableBoxPopup">
            <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64.png" height="15" width="15">
          </button>
        </div>
        <div v-if="!isFreeText" class="filter-details" :style="{ backgroundColor: isDisabled ? 'rgba(200,200,200,0.3)' : '', opacity: isDisabled ? '0.8' : '1' }" ref="filterDetails">
          <div v-if="confirmedData.length == 0">{{ noneSelectedText }}</div>
          <!-- <div v-for="(s, i) in confirmedData" :key="i" class="item" :title="s[itemDesc]">{{ s[itemKey] }}</div> -->
          <div v-for="(s, i) in confirmedData" :key="i" class="item" :title="s[itemDesc]">
            <span>{{ s[itemKey] }}</span>
            <button v-if="!isDisabled" class="item-delete-btn" @click="removeItem(i)" title="Remove item">
              <img src="https://dsmlib.logistics.systems/Icons/icons8-minus-48.png" height="13px" /> 
            </button>
          </div>
        </div>
        <textarea v-else :title="`Enter the ${title}, 1 ${title} per line`" v-model="textItem"></textarea>
        <div v-if="errorMessage" class="error-message-container" :style="errorMessageContainerStyling">
          <span>{{errorMessage}}</span>
        </div>
      </div>
    </div>

    <div v-if="showTabulator" class="tabulator-popup" :style="{ height: isFullScreen ? '100%' : 'calc(100% - 50px)', top: isFullScreen ? '0' : '50px' }">
      <div class="popup-container">
        <!-- <div class="popup-header">
          <div class="title">Select {{ title }} (Max {{ maxSelection }} items)</div>
        </div> -->
        <div class="tabulator-container">
          <TableBox :title="`Select ${title} (Max ${maxSelection} items)`" :tableData="tableData" :selectedRow.sync="selectedItem" :maxSelection="maxSelection"
            :rollSelection="false" :hideColumns="tableBoxHideColumns" />
        </div>
        <div class="confirm-cancel-button">
          <button v-if="tableData.length > 0" @click="confirmClicked">{{ selectedItem.length > 0 ? `Confirm ${selectedItem.length} items` : noneSelectedConfirmButtonText }}</button>
          <button @click="cancelClicked">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      errorMessageContainerStyling: {
        // webkit line clamp is needed if the ellipsis needs to be shown not on the first line, but at the end of a few number of lines
        // https://stackoverflow.com/a/17029025 https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp https://css-tricks.com/almanac/properties/l/line-clamp/
        // webkit line clamp is supported across all major browsers, but as of writing this line clamp is being defined in the CSS standard
        // which will replace webkit line clamp in the future

        "display": "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "1", // the number of lines needs to be specified, and needs to be greater than 0
      },
      showTabulator: false,
      selectedItem: [],
      confirmedData: [],
    }
  },
  props: {
    title: { type: String, default: 'Filters' }, // Title to show above the filter box
    tableData: { type: Array, default: function() { return []; } }, // The data to populate in the table box
    maxSelection: { type: Number, default: 50 }, // Set the max selection of data
    itemKey: { type: String, default: '' }, // The item key to show in the box when it is selected
    itemDesc: { type: String, default: '' }, // The desc key to show when the selected items is hover on
    noneSelectedText: { type: String, default: "All" }, // Text to show when no items are selected
    noneSelectedConfirmButtonText: { type: String, default: "Select All" }, // Button text to show when no items are selected in the table box
    selectedObject: { type: Array, default: function() { return []; }}, // The objects of the selected items
    isFullScreen: { type: Boolean, default: false }, // Set to true so that the popup is full screen
    tableBoxHideColumns: { type: Array, default: function() { return []; }}, // Columns to hide in the table box

    // =============== consider removing in the future?
    isFreeText: { type: Boolean, default: false }, // When set to true, user can type in the items, 1 item per line
    textItem: { type: String, default: '' },

    isDisabled: { type: Boolean, default: false }, // controls whether the edit button is enabled or disabled
    isRequired: { type: Boolean, default: false }, // controls whether red asterisks next to title are shown or hidden
    errorMessage: { type: String, default: '' }, // set an error message, use .sync

    // public events
    // @confirmClicked(confirmedData) - fired when the confirm button is clicked on the TableBox popup

    // public methods
    // showTableBoxPopup() // shows the TableBox popup for users to pick which items to select
  },
  methods: {
    confirmClicked: function() {
      this.showTabulator = false;
      this.confirmedData = [...this.selectedItem];

      this.$emit('update:selectedObject', this.confirmedData);
      this.$emit('update:errorMessage', '');
      this.$emit('confirmClicked', this.confirmedData);
    },
    cancelClicked: function() {
      this.showTabulator = false;
      this.selectedItem = [...this.confirmedData];
    },

    showTableBoxPopup: function() { // public method
      this.showTabulator = true;
    },
    removeItem: function(index) {
      this.confirmedData.splice(index, 1);
      this.selectedItem = [...this.confirmedData];

      this.$emit('update:selectedObject', this.confirmedData);
      this.$emit('update:errorMessage', '');
      this.$emit('confirmClicked', this.confirmedData);
    },
  },
  mounted() {
    if (Array.isArray(this.selectedObject)) {
      this.selectedItem = [...this.selectedObject];
      this.confirmedData = [...this.selectedObject];
    }

    // update error message styling, this logic was moved from computed to mounted instead
    // computed properties runs before mounted, which will cause issues if the component is initialised with an error message set, because it tries to calculate the amount of available space before the UI is rendered
    // https://stackoverflow.com/questions/50547854/run-computed-function-after-mounted-vue
    // this will also not react if the component is resized while shown, create a resize observer if needed
    const boundingClientRect = this.$refs.filterDetails.getBoundingClientRect();
    const contentHeight = boundingClientRect.height - 6; // minus off padding and some extra pixels, just to be sure that it won't exceed past the component's boundaries
    const numberOfLines = Math.floor(contentHeight / 15); // one line is approximately 15 pixels
    this.errorMessageContainerStyling["-webkit-line-clamp"] = numberOfLines ? numberOfLines.toString() : "1"; // the number of lines needs to be greater than 0
  },
  watch: {
    selectedObject: function(val) {
      if (Array.isArray(val)) {
        this.selectedItem = [...val];
        this.confirmedData = [...val];
      } else {
        this.selectedItem = [];
        this.confirmedData = [];
      }
    },
    showTabulator: function(val) {
      if (val) {
        let temp = this.selectedItem;
        this.selectedItem = [];
        this.$nextTick(() => this.selectedItem = temp);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.filters-main {
  height: 100%;
  width: 100%;

  > .filters {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    
    > .filter-items {
      min-width: calc(50% - 10px);
      flex-grow: 1;
      margin: 2px;
      font-size: 10px;
      display: flex;
      flex-direction: column;
      position: relative;

      > .filter-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        height: 15px;
        width: 100%;

        .required-asterisks {
          margin-right: 5px;
          color: red;
        }

        > button {
          margin: 0 2px;
          padding: 1px 2px;
        }
      }

      > .filter-details {
        padding: 0 3px;
        height: calc(100% - 20px);
        border: 1px solid rgb(200,200,200);
        margin-top: 2px;
        position: absolute;
        width: 100%;
        top: 16px;
        overflow-y: auto;

        > .item {
          cursor: pointer;
          padding: 2px;
          display: flex;
          align-items: center;

          &:hover {
            background-color: rgba(200,200,200,0.5);

            .item-delete-btn {
              visibility: visible;
              opacity: 1;
            }
          }

          > span {
            flex: 0 0 70%;   
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .item-delete-btn {
            flex: 0 0 30%;   
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 1px;

            visibility: hidden;
            opacity: 0;

            background: transparent;
            border: none;
            cursor: pointer;

            transition: opacity 0.15s ease, visibility 0.15s;

            img {
              pointer-events: none; 
            }
          }
        }

        > .filter-empty {
          background-color: red;
          color: white;
          padding: 5px;
          border-radius: 5px;
          position: absolute;
          left: 3px;
          top: 3px;
          width: calc(100% - 6px);
          cursor: text;
        }
      }

      > textarea {
        position: absolute;
        height: calc(100% - 17px);
        resize: none;
        width: 100%;
        top: 17px;
        border: 1px solid rgb(200,200,200);

        &:focus {
          outline: none;
        }
      }

      > .error-message-container {
        position: absolute;
        border-radius: 5px;
        padding: 1px 5px;
        top: 20px; // height of the filters title
        left: 2px;
        max-height: calc(100% - 25px);
        max-width: calc(100% - 4px);
        background-color: red;
        color: white;
        display: flex;
        overflow: hidden;
      }

      > .filter-details:hover ~ .error-message-container, .error-message-container:hover {
        border: 1px solid black;
        max-height: unset;
        max-width: unset;
        -webkit-line-clamp: unset !important; // used to display the ellipsis after a subsequent number of lines
      }
    }
  }

  > .tabulator-popup {
    width: 100%;
    height: calc(100% - 50px);
    position: fixed;
    left: 0;
    top : 50px;
    background-color: rgba(200,200,200,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    // z-index: 1001;
    z-index: 1111;

    > .popup-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      background-color: white;
      width: 90%;
      height: 90%;
      padding: 10px;

      > .popup-header {
        display: flex;
        align-items: center;

        > .title {
          font-weight: bold;
          font-size: 15px;
          margin: 0 10px;
        }
      }

      > .tabulator-container {
        position: relative;
        height: calc(100% - 33px);
        width: 100%;
      }

      > .confirm-cancel-button {
        position: relative;
        margin-top: 10px;
        display: flex;

        > button {
          margin: 0 5px;
        }
      }
    }
  }
}
</style>